(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.components:mxLiteral
	 * @module mx.components
	 * @restrict 'E'
	 * @scope {}
	 * @description Displays the value.
	 *    if attribute `designer-mode` is set then One-time-binding will be applied. while scope.value === 'undefined' One-time-binder will be waiting until it get some other value.
	 *    If it's need to set value as  "not set ""- set it as `null`
	 *
	 * @param {string} label@ - Optional. Label of the control.
	 * @param {value} value= - Value to display.
	 * @param {string} type@ - Optional. Type of the value.
	 * @param {string} format@ - Optional. Data format to be displayed (example: short date: 5/20/16 10:32 AM)
	 * @param {boolean} singleLine@ - Optional. Text to be displayed in single or multi line
	 * @param {boolean} hideOnEmptyValue@ - Optional. Hide control if value is empty
	 * @param {string} icon@ - Optional. Icon to be displayed.
	 * @param {boolean} reserveIconSpace@ - Optional. Reserve empty space for icon.
	 * @param {boolean} designerMode@ - Optional.
	 * @param {boolean} labelPosition@ - Optional. Position of label to be displayed (example: top, bottom). Default: left
	 * @usage <mx-literal data-label="Text, single line, undefined , hide-on-empty-value" data-value="vm.text3" data-single-line="true" hide-on-empty-value="true"></mx-literal>
	 */
	angular.module('mx.components').directive('mxLiteral', [
		'$filter',
		'$sce',
		'mx.internationalization',
		'mx.shell.Config',
		function mxLiteralDirective($filter, $sce, i18n, mxConfig) {
			var notSetLabel = i18n.get('components.mx-literal.notSet');
			var notSetAriaLabel = i18n.get('components.mx-literal.ARIA-valueIsNotSet');
			var yesLabel = i18n.get('components.common.yes');
			var noLabel = i18n.get('components.common.no');
			var config = mxConfig.get('currency');
			const displayLinksCount = 3;

			function getOptimizer(attrs) {
				return attrs.designerMode !== undefined && ('' + attrs.designerMode).toLowerCase() !== 'false' ? '' : '::';
			}

			function mxLiteralTpl(elem, attr) {
				var optimizer = getOptimizer(attr);

				var literalResized = attr.valueMinWidth !== undefined || attr.labelMinWidth !== undefined || attr.labelMaxWidth !== undefined ? 'mx-literal-resize' : '';

				return (
					`<div
						layout="row"
						class="
							mx-literal
							{{${optimizer}formattedLabelPosition}}
							${literalResized}
							{{${optimizer}reserveIconSpace === 'true' || icon ? 'reserveSpace' : ''}}
							{{${optimizer}position !== 0 ? 'vertical' : ''}}
							{{${optimizer}singleLine !== 'true' ? 'multi-line' : ''}}
							{{show ? '' : 'without-value'}}
							{{${optimizer}label ? 'with-label' : ''}}
							{{${optimizer}icon || reserveIconSpace==='true' ? 'with-icon' : ''}}
						"
						role="region">` +
					`<div class="label-value" layout="{{${optimizer}layout}}">${
						getIconTemplate(attr, optimizer) + getLabelTemplate(attr, optimizer) + getTemplateByType(attr, optimizer)
					}</div>` +
					`</div>`
				);
			}

			function getTemplateByType(attr, optimizer) {
				var template;
				var ngValueStyle = ngStyleTmpl(attr, 'color:valueColor, minWidth:valueMinWidth', optimizer);
				var singleLineClass = attr.singleLine === 'true' ? 'single-line' : '';

				var linkFunc = function (idx, notLast) {
					var value = 'value';
					var ngIf = '';
					var showComma = '';

					if (idx !== undefined) {
						value = `value[${idx}]`;
						ngIf = ` ng-if="${optimizer}${value}"`;
						showComma = `<span ng-if="${optimizer} value[${idx}].text && value[${idx + 1}].text">;${notLast ? ' ' : '&nbsp;&mldr;'}</span>`;
					}

					return `<a
							class="literal-value {{${optimizer} hasValue ? undefined : 'no-value' }}"
							ng-click="!showText && onClick($event, ${idx})"
							aria-label="{{${optimizer}label}}, {{${optimizer}${value}.ariaValue || ${value}.text }}."
							ng-href="{{${optimizer}${value}.href}}"
							${ngValueStyle}
							${ngIf}
							##ngclass##
						>{{${optimizer}${value}.text}}</a>${showComma}`;
				};

				switch (attr.type) {
					case 'link':
						template = linkFunc();
						break;

					case 'links':
						template = `<div class="literal-value mx-object-links--links-spree" ${ngValueStyle}>`;
						for (var i = 0; i < displayLinksCount; i++) {
							template += linkFunc(i, i < displayLinksCount - 1);
						}
						break;

					case 'html':
						var bindType = attr.compileHtml === 'true' ? 'mx-bind-html-trusted' : 'ng-bind-html';
						template = `<div
										${ngValueStyle}
										class="literal-value ${singleLineClass}"
										${bindType}="${optimizer}formattedValue"
										##ngclass##
									></div><span class="mx-aria-only">.</span>`;
						break;

					case 'bool':
						template =
							`<div
								${ngValueStyle}
								class="literal-value"
								aria-hidden="true"
								##ngclass##
							>` +
							`{{${optimizer}value ? "${yesLabel}":"${noLabel}"}}` +
							`</div>` +
							`<span class="mx-aria-only">{{${optimizer}value ? "${yesLabel}":"${noLabel}"}}.</span>`;
						break;

					default:
						var style = ngStyleTmpl(attr, 'minWidth:valueMinWidth', optimizer);
						switch (attr.textType) {
							case 'phone':
								template =
									`<div class="layout-row" ${style}>` +
									`<div ng-if="${optimizer}(value)">` +
									`<a
										href="tel:{{${optimizer}getPurePhone(value)}}"
										title="{{${optimizer} ('components.mx-literal.ARIA-makeACall' | mxi18n) + ' ' + formattedValue}}." >` +
									`<md-icon
										${ngStyleTmpl(attr, 'color:iconColor', optimizer)}
										class="md-48 callto"
										aria-hidden="true"
										role="none"
									>phone_forwarded</md-icon>` +
									`</a>` +
									`</div>` +
									`<div
										aria-hidden="true"
										${ngValueStyle}
										ng-bind="${optimizer}formattedValue"
										class="literal-value phone${singleLineClass}"
										##ngclass##
									></div>` +
									`</div>`;
								break;
							case 'email':
								template =
									`<div
										class="layout-row"
										${style}
										ng-if="${optimizer}value">` +
									`<a ${ngValueStyle} href="mailto:{{${optimizer}value}}">{{${optimizer}value}}</a>` +
									`</div>`;
								break;
							default:
								template =
									`<div
										${ngValueStyle}
										ng-bind="${optimizer}formattedValue"
										aria-hidden="true"
										class="literal-value ${singleLineClass}"
										##ngclass##
										${style}>` +
									`</div>` +
									`<p class="mx-aria-only">{{${optimizer}ariaValue || formattedValue}} .</p>`;
								break;
						}

						break;
				}

				return template.replace(/##ngclass##/g, `ng-class="${optimizer}label ? 'with-label': 'without-label'"`);
			}

			function getIconTemplate(attr, optimizer) {
				return (
					`<div
						ng-if="${optimizer}(icon || reserveIconSpace===&quot;true&quot;)"
						class="icon"
						aria-hidden="true"
						role="none">` +
					`<mx-icon icon="{{${optimizer}icon}}" color="{{${optimizer}iconColor}}"></mx-icon>` +
					`</div>`
				);
			}

			function getLabelTemplate(attr, optimizer) {
				var ngLabelStyle = ngStyleTmpl(attr, 'color:labelColor, minWidth:labelMinWidth, maxWidth:labelMaxWidth', optimizer);
				var classes = attr.singleLine === 'true' ? ' class="single-line"' : '';
				var isLinkType = attr.type === 'link' || attr.type === 'links';

				return (
					`<label
						ng-show="${optimizer}label"
						aria-hidden="${isLinkType || `{{ ${optimizer} !label }}`}"
						${ngLabelStyle}
						${classes}
					>` +
					`<span class="mx-literal-label-text">{{${optimizer}label}}</span>` +
					`</label>` +
					(isLinkType ? `` : `<span ng-show="${optimizer}label" class="mx-aria-only">,</span>`) // ARIA: small pause when reading
				);
			}

			// This function exclude not needed styles from template
			function ngStyleTmpl(attr, styleStr, optimizer) {
				var styles = styleStr
					.split(',')
					.map(function (strStyle) {
						var value = strStyle.split(':')[1].trim();
						return attr[value] !== undefined ? strStyle : '';
					})
					.filter(function (st) {
						return st;
					});
				return styles.length ? `ng-style="${optimizer} { ${styles.join(', ')} }"` : '';
			}

			function mxLiteralCtrl(scope, element, attrs) {
				var optimizer = getOptimizer(attrs);

				scope.hasValue = true;
				scope.show = true;
				scope.formattedLabel = scope.label;
				scope.formattedHideOnEmptyValue = (scope.hideOnEmptyValue || '').toLowerCase() === 'true';
				scope.formattedReserveIconSpace = (scope.reserveIconSpace || '').toLowerCase() === 'true';
				scope.$watch(optimizer + 'labelPosition', function () {
					calcPositionLayout();
				});

				var type = (scope.type || '').toLowerCase();
				var isDateType = type === 'date' || type === 'datetime';
				var isCurrency = type === 'currency';
				var isHtml = type === 'html';
				var isNumeric = type === 'numeric';
				var isTimeSpan = type === 'timespan';

				if (type === 'link' || type === 'links') {
					var isLinks = type === 'links';

					scope.$watch(
						optimizer + (type === 'link' ? 'value.text' : 'value[0]'),
						function () {
							var val = scope.value;

							if (isLinks && Array.isArray(val)) {
								val = val.length ? val[0] : undefined;
							}
							var newText = val ? val.text : undefined;
							if ((angular.isDefined(newText) && newText !== notSetLabel) || (angular.isUndefined(newText) && val === null)) {
								if (val) {
									if (val.onClick) {
										scope.onClick = function (event, indx) {
											var val = scope.value;
											if (Array.isArray(val)) {
												val = val[indx];
											}
											val.onClick();
											event.stopPropagation();
											event.preventDefault();
										};

										if (!isLinks && !scope.value.href) {
											scope.value.href = '#';
										} else if (isLinks) {
											scope.value.forEach((value) => {
												value.href ??= '#';
											});
										}
									}

									scope.show = true;
									scope.showText = scope.value.isText;
									if (scope.value.text === '') {
										val.text = notSetLabel;
										val.ariaValue = notSetAriaLabel;
									}
									scope.hasValue = val.text !== '';
								} else {
									scope.hasValue = false;
									scope.show = !scope.formattedHideOnEmptyValue;
									if (scope.show) {
										scope.showText = true;
										scope.value = { text: notSetLabel, ariaValue: notSetAriaLabel };
										if (isLinks) {
											scope.value = [scope.value];
										}
									}
								}

								// for Not Watchable case: fulfill not set items by empty values not to update on change
								if (isLinks && optimizer === '::' && scope.value?.[0] && scope.value.length < displayLinksCount + 1) {
									for (let i = 0; i < displayLinksCount + 1; i++) {
										scope.value[i] ??= { text: '', href: '#' };
									}
								}
							} else {
								scope.show = !scope.formattedHideOnEmptyValue;
							}

							scope.informContainerOwnVisibility(scope.show);
						},
						isLinks
					);
				} else {
					var rmValueWatcher = scope.$watch(
						function (_scope) {
							var val = isCurrency ? _scope.value?.CC + _scope.value?.Value : _scope.value;
							if (
								optimizer === '::' &&
								(typeof val !== 'undefined' || (isCurrency && typeof _scope.value?.CC !== 'undefined' && typeof _scope.value?.Value !== 'undefined'))
							) {
								rmValueWatcher();
							}
							return val;
						},
						function (newValue, oldValue, scope) {
							setValue(newValue, oldValue, scope, {
								type: type,
								isDateType: isDateType,
								isCurrency: isCurrency,
								isHtml: isHtml,
								isNumeric: isNumeric,
								isTimeSpan: isTimeSpan,
							});
						}
					);
				}

				var textType = (scope.textType || '').toLowerCase();
				if (textType === 'phone') {
					scope.getPurePhone = function (phone) {
						if (phone && phone.replace) {
							return phone.replace(/[^0-9+]/g, '');
						}
						return phone;
					};
				}

				if (isNumeric) {
					scope.valueType = attrs.valueType || '';
				}

				function calcPositionLayout() {
					scope.position = scope.labelPosition === 'bottom' ? 2 : scope.labelPosition === 'top' ? 1 : 0;
					scope.layout = scope.position === 0 ? 'row' : 'column';
					scope.formattedLabelPosition = scope.labelPosition || 'left';
				}

				function setValue(newValue, oldValue, scope, params) {
					var _value = scope.value;

					// while scope.value === 'undefined' One-time-binder will be waiting until it get some other value.
					// If you need to set value as not set - set it as `null`
					if (typeof _value !== 'undefined') {
						const isRealNumber = (value) => typeof value === 'number' && !isNaN(value) && isFinite(value);

						scope.hasValue =
							(params.isNumeric && isRealNumber(_value)) ||
							(params.isCurrency && _value && isRealNumber(_value.Value)) ||
							(Boolean(_value) && !params.isNumeric && !params.isCurrency);

						if (scope.hasValue) {
							switch (true) {
								case params.isDateType:
									scope.formattedValue = i18n.formatUTCDate(_value, scope.format);
									scope.ariaValue = i18n.formatUTCDate(_value, 'LLL');
									break;
								case params.isCurrency:
									scope.formattedValue = i18n.formatCurrency(_value, _value.CC, !config.showCurrencyCode);
									break;
								case params.isHtml:
									scope.formattedValue = mx.components.Utils.isolateLocalStyles(_value);
									break;
								case params.isNumeric:
									scope.formattedValue = i18n.formatNumber(_value, scope.valueType, scope.format);
									break;
								case params.isTimeSpan:
									scope.formattedValue = i18n.formatTimeDuration(_value);
									scope.ariaValue = i18n.formatTimeDuration(_value, true);
									break;
								default:
									scope.formattedValue = _value;
									break;
							}
							scope.show = Boolean(scope.formattedValue);
						} else {
							scope.show = !scope.formattedHideOnEmptyValue;
							if (scope.show) {
								scope.formattedValue = notSetLabel;
								scope.ariaValue = notSetAriaLabel;
							}
						}
					} else {
						scope.show = false;
					}

					scope.informContainerOwnVisibility(scope.show);
				}
			}

			return {
				require: {
					mxContainerCtrl: '?^^mxContainer',
				},
				link: function (scope, el, attrs, ctrls) {
					scope.informContainerOwnVisibility = function () {};
					if (ctrls.mxContainerCtrl) {
						ctrls.mxContainerCtrl.registerChild(scope);
						scope.informContainerOwnVisibility = ctrls.mxContainerCtrl.setChildVisibility.bind(null, scope);
					}
				},
				restrict: 'E',
				replace: true,
				scope: {
					label: '@',
					value: '<',
					type: '@',
					format: '@',
					singleLine: '@',
					hideOnEmptyValue: '@',
					icon: '@',
					reserveIconSpace: '@',
					// while scope.value === 'undefined' One-time-binder will be waiting until it get some other value.
					// If you need to set value as not set - set it as `null`
					designerMode: '<?',
					valueMinWidth: '@',
					labelMinWidth: '@',
					labelMaxWidth: '@',
					labelPosition: '@',
					labelStyle: '@',
					labelColor: '@',
					valueColor: '@',
					iconColor: '@',
					textType: '@',
					compileHtml: '@',
				},
				template: mxLiteralTpl,
				controller: ['$scope', '$element', '$attrs', mxLiteralCtrl],
			};
		},
	]);
})();
